import type { PlaygroundOp } from "../types";
import { DOT, choice } from "./styles";

const OPS: Array<{
  id: PlaygroundOp;
  label: string;
  hint: string;
}> = [
    {
      id: "search",
      label: "Search",
      hint: "Semantic + keyword search: 11M+ papers, FDA docs, trials, proteins",
    },
    {
      id: "grep",
      label: "Grep",
      hint: "Exact regex over the full text of 11M+ papers, in seconds",
    },
    {
      id: "map",
      label: "Map",
      hint: "Ask an LLM reader the same question about every paper in a result set",
    },
    {
      id: "citations",
      label: "Citations",
      hint: "Explore a paper's citation neighborhood as an interactive graph",
    },
    {
      id: "console",
      label: "Console",
      hint: "A live shell for any paperclip command — or let an agent type it for you",
    },
  ];

export const OperationTabs = ({
  value,
  onChange,
  hiddenOps = [],
}: {
  value: PlaygroundOp;
  onChange: (op: PlaygroundOp) => void;
  /** Ops gated off by feature flags (e.g. citations via citegraphExplorer). */
  hiddenOps?: PlaygroundOp[];
}) => {
  const visibleOps = OPS.filter((op) => !hiddenOps.includes(op.id));
  const active = visibleOps.find((op) => op.id === value);
  return (
    <div>
      <div
        role="tablist"
        aria-label="Playground operation"
        className="flex flex-wrap items-baseline gap-x-3"
      >
        {visibleOps.map((op, i) => (
          <span key={op.id} className="flex items-baseline gap-x-3">
            {i > 0 && <span aria-hidden className={DOT}>·</span>}
            <button
              type="button"
              role="tab"
              aria-selected={op.id === value}
              onClick={() => onChange(op.id)}
              className={choice(op.id === value)}
            >
              {op.label}
            </button>
          </span>
        ))}
      </div>
      {active && (
        <p className="mt-2 text-sm leading-6 italic text-zinc-500">
          {active.hint}
        </p>
      )}
    </div>
  );
};
